import React from "react";
import BasicModal from "../../../../core/BaseComponents/Modal";

function PreviewCustomizeWelcomeScreen({showPreviewPopUp, setShowPreviewPopUp}) {
  return (
    <BasicModal
      popupOpen={showPreviewPopUp}
      popupCloseHandler={() => {setShowPreviewPopUp('') }}
      isCross={true}
      heading={`Default Welcome Screen ${showPreviewPopUp?.split('.').pop()==="mp4"?"Video":"Image"} Preview`}
      popupSize={`px-5 ${showPreviewPopUp?.split('.').pop()==="mp4"?"col-8":"col-11"}`}
      bodyMessage={
        <div className="preview-banner-img">
          {showPreviewPopUp?.split('.').pop()==="mp4"?<video className="w-100" controls={true} preload="metadata" >
          <source src={`${showPreviewPopUp}`} type="video/mp4" />
        </video>:
          <img src={showPreviewPopUp} alt='bg-image' width={100} style={{ 
            maxHeight: showPreviewPopUp?.split('.').pop() === "mp4" ? '40vh' : '80vh' 
          }}/>}
        </div>
      }
    />
  );
}

export default PreviewCustomizeWelcomeScreen;
